import { ContactRole } from '@shared/types/contact-role';

export const contactRoles: {
  reference: ContactRole;
  title: string;
  icon: string;
  description: string;
  allowMultipleContacts: boolean;
  color: string;
}[] = [
  {
    reference: 'primary',
    title: 'Primary',
    icon: 'call-outline',
    description: 'Main contact for the organisation',
    allowMultipleContacts: false,
    color: 'turquoise-mid',
  },
  {
    reference: 'accounts',
    title: 'Accounts',
    icon: 'wallet-outline',
    description: 'Email Recipient for invoices and statements',
    allowMultipleContacts: false,
    color: 'blue-dark',
  },
  {
    reference: 'strategic',
    title: 'Strategic',
    icon: 'business-outline',
    description: 'Authorised owner of the relationship with ESET',
    allowMultipleContacts: true,
    color: 'bright-lilac-standard',
  },
  {
    reference: 'partner',
    title: 'System Notifications',
    icon: 'mail-outline',
    description: 'Partner recipient for customer license emails & expiry reminders',
    allowMultipleContacts: false,
    color: 'blue-muted-standard',
  },
  {
    reference: 'sales',
    title: 'Sales',
    icon: 'cart-outline',
    description: 'Responsible for quotes, orders & sales discussions',
    allowMultipleContacts: true,
    color: 'blue-electric',
  },
  {
    reference: 'technical',
    title: 'Technical',
    icon: 'construct-outline',
    description: 'Responsible for deployment, support & product guidance',
    allowMultipleContacts: true,
    color: 'bright-orange',
  },
  {
    reference: 'marketing',
    title: 'Marketing',
    icon: 'megaphone-outline',
    description: 'Responsible for campaigns, promotions & partner communications',
    allowMultipleContacts: true,
    color: 'bright-yellow',
  },
];

export const singleUseRoles = contactRoles
  .filter((contactRole) => !contactRole.allowMultipleContacts)
  .map((contactRole) => contactRole.reference);
